import router from "./router";
import storage from 'store'
import store from '@/store/index'
import * as request from '@/request/common'
import { setDocumentTitle } from '@/utils/domUtil'
import { key } from '@/config';

router.beforeEach( async (to, from, next) => {
    // 设置标题|描述|关键字
    if (to.meta && typeof to.meta.title !== 'undefined') {
        setDocumentTitle(to.meta.title);
    }
    const meetingInfo = await store.dispatch('getMeetingInfo',{meeting_id:to.params.meeting_id});

    // 如果参数中存在unified则代表需要登录
    if (to.query.unified && !store.getters.userInfo?.Mobile) {
        request.post({url:'UnifiedLogin', data:{
            unified: to.query.unified
        }}).then(res => {
            storage.set('auth', res.data);
            request.get({url:'GetUserInfoByUserId',headers:{key}}).then(res => {
                store.commit('updateState', { userInfo: res.data });
                let query = JSON.parse(JSON.stringify(to.query));
                query.unified && (delete query.unified);
                next({
                    path: to.path,
                    replace: true,
                    query
                })
            }).catch(err => {
                console.log(err);
            })
        })
    }else{
        let auth = storage.get('auth');
        // 需要登陆
        if(to.meta.auth){
            // 存在token 不存在登陆信息
            if(auth){
                if(!store.getters.userInfo?.user_id){
                    request.get({url:'GetUserInfoByUserId',headers:{key}}).then(res => {
                        store.commit('updateState', { userInfo: res.data });
                        next()
                    })
                }else{
                    next();
                }
            }else{
                let href = window.location.href;
                // 去除过多的unified
                href = href.split('unified=');
                href = href[0];
                let committee_login_url = storage.get('committee_login_url');
                window.location.href = committee_login_url+"/unified/login?return_url="+encodeURIComponent(href);
            }
        }else{
            next()
       }
    }
})

router.afterEach((to, from) => {

})